var _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g3, _ellipse, _g4, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRejected = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 320,
  height: 262,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_dd_854_25322)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M261.82 97.4178L168.452 73.3107C165.554 72.251 161.456 73.0703 159.759 74.7278L65.2056 167.422C64.7457 167.873 64.0629 168.087 63.8801 168.827C63.4431 170.596 66.1329 174.667 68.0759 175.175L166.721 200.949C169.039 201.555 172.294 200.702 173.992 199.045L267.706 107.077C270.219 103.903 264.138 98.0236 261.82 97.4178Z",
  fill: "url(#paint0_linear_854_25322)"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M262.179 97.5186L166.824 72.6042C163.618 71.7665 159.095 72.9628 156.723 75.2762L64.4908 165.212C62.1183 167.525 62.7941 170.08 66.0001 170.918L159.421 195.326C163.696 196.443 169.725 194.848 172.889 191.764L263.689 103.224C266.061 100.911 265.386 98.3563 262.179 97.5186Z",
  fill: "white"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_f_854_25322)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M173.606 193.547L264.146 103.667C266.359 101.47 265.845 99.05 262.966 98.1143L258.297 96.5966L167.53 73.28C164.328 72.4574 159.833 73.6505 157.465 75.9513L64.9628 165.857C62.6031 168.151 63.2386 170.69 66.3881 171.551L159.978 197.14C164.282 198.317 170.436 196.694 173.606 193.547Z",
  fill: "url(#paint1_linear_854_25322)"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M262.179 97.5186L166.824 72.6042C163.618 71.7665 159.095 72.9628 156.723 75.2762L64.4908 165.212C62.1183 167.525 62.7941 170.08 66.0001 170.918L159.421 195.326C163.696 196.443 169.725 194.848 172.889 191.764L263.689 103.224C266.061 100.911 265.386 98.3563 262.179 97.5186Z",
  fill: "url(#paint2_linear_854_25322)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M155.666 88.4055C156.494 87.6748 158.029 87.318 159.095 87.6085L246.548 111.448C247.613 111.739 247.806 112.567 246.977 113.297L244.638 115.361C243.809 116.092 242.274 116.448 241.208 116.158L153.756 92.3182C152.69 92.0277 152.497 91.1999 153.326 90.4692L155.666 88.4055Z",
  fill: "#F3F0FF"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M145.388 97.7776C146.216 97.0469 147.752 96.6901 148.817 96.9806L236.27 120.82C237.335 121.111 237.528 121.939 236.699 122.669L234.424 124.676C233.595 125.407 232.06 125.764 230.994 125.473L143.542 101.634C142.476 101.343 142.284 100.515 143.112 99.7848L145.388 97.7776Z",
  fill: "#F3F0FF"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M134.878 107.509C135.706 106.779 137.241 106.422 138.307 106.713L225.76 130.552C226.825 130.843 227.018 131.671 226.189 132.401L223.196 135.041C222.368 135.772 220.832 136.129 219.767 135.838L132.314 111.998C131.249 111.708 131.056 110.88 131.885 110.149L134.878 107.509Z",
  fill: "#F3F0FF"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M115.743 126.974C116.572 126.243 118.107 125.886 119.173 126.177L166.009 138.945C167.075 139.235 167.267 140.063 166.439 140.794L164.158 142.806C163.329 143.537 161.794 143.893 160.728 143.603L113.892 130.835C112.826 130.545 112.633 129.717 113.462 128.986L115.743 126.974Z",
  fill: "#F3F0FF"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M124.185 118.458C125.014 117.728 126.549 117.371 127.615 117.661L174.451 130.429C175.517 130.72 175.709 131.547 174.881 132.278L172.599 134.29C171.771 135.021 170.236 135.378 169.17 135.087L122.333 122.32C121.268 122.029 121.075 121.201 121.904 120.471L124.185 118.458Z",
  fill: "#F3F0FF"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M100.481 145.221C101.309 144.49 102.845 144.133 103.911 144.424L186.02 166.807C187.086 167.098 187.278 167.925 186.45 168.656L184.168 170.668C183.34 171.399 181.804 171.756 180.739 171.465L98.6293 149.082C97.5636 148.792 97.3712 147.964 98.1996 147.233L100.481 145.221Z",
  fill: "#F3F0FF"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M92.9962 153.737C93.8246 153.006 95.36 152.649 96.4257 152.94L164.27 171.434C165.336 171.725 165.528 172.552 164.7 173.283L162.418 175.295C161.59 176.026 160.054 176.383 158.989 176.092L91.1444 157.598C90.0787 157.307 89.8864 156.48 90.7148 155.749L92.9962 153.737Z",
  fill: "#F3F0FF"
})), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_d_854_25322)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M224.297 87.3345C219.775 91.7445 211.052 94.2036 204.814 92.8272C202.155 92.2406 200.377 91.0518 199.561 89.5393C197.137 85.3047 199.112 84.8805 201.707 82.3502C206.23 77.9403 214.953 75.4811 221.191 76.8575C223.771 77.4267 225.179 76.8907 226.368 80.0115C227.174 82.1288 226.949 84.7484 224.297 87.3345Z",
  fill: "url(#paint3_linear_854_25322)"
}))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  rx: 11.5667,
  ry: 11.4373,
  transform: "matrix(0.976512 0.215461 -0.715963 0.698138 212.278 83.4302)",
  fill: "white"
})), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_d_854_25322)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M137.042 109.146C115.937 102.771 85.7761 108.189 69.8693 121.213C53.9624 134.237 58.1985 150.044 79.3038 156.419C100.409 162.794 130.569 157.376 146.476 144.353C162.383 131.329 158.147 115.521 137.042 109.146ZM114.403 142.107C114.676 143.128 113.291 144.262 111.343 144.612C110.335 144.793 109.405 144.739 108.678 144.519C107.95 144.299 107.424 143.914 107.283 143.386L105.113 135.288L89.663 138.064C88.6554 138.245 87.7255 138.19 86.9978 137.97C86.27 137.751 85.7443 137.365 85.6028 136.837C85.3292 135.816 86.7149 134.682 88.6629 134.332L104.113 131.556L101.943 123.459C101.669 122.438 103.055 121.304 105.003 120.954C106.951 120.604 108.789 121.159 109.063 122.18L111.233 130.277L126.683 127.502C128.631 127.152 130.469 127.707 130.743 128.728C131.016 129.749 129.631 130.884 127.683 131.234L112.233 134.009L114.403 142.107Z",
  fill: "#BFBFD0"
}))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M137.042 107.93C115.937 101.555 85.7761 106.973 69.8693 119.996C53.9624 133.02 58.1985 148.828 79.3038 155.203C100.409 161.577 130.569 156.159 146.476 143.136C162.383 130.112 158.147 114.304 137.042 107.93ZM114.403 140.89C114.676 141.911 113.291 143.045 111.343 143.395C110.335 143.576 109.405 143.522 108.678 143.302C107.95 143.082 107.424 142.697 107.283 142.169L105.113 134.072L89.663 136.847C88.6554 137.028 87.7255 136.974 86.9978 136.754C86.27 136.534 85.7443 136.149 85.6028 135.62C85.3292 134.6 86.7149 133.465 88.6629 133.115L104.113 130.34L101.943 122.242C101.669 121.221 103.055 120.087 105.003 119.737C106.951 119.387 108.789 119.942 109.063 120.963L111.233 129.061L126.683 126.285C128.631 125.935 130.469 126.491 130.743 127.512C131.016 128.533 129.631 129.667 127.683 130.017L112.233 132.792L114.403 140.89Z",
  fill: "#D4D4E0"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_dd_854_25322",
  x: 43.833,
  y: 42.8359,
  width: 244.471,
  height: 186.308,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -10
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_854_25322"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.21 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_854_25322",
  result: "effect2_dropShadow_854_25322"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_854_25322",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_854_25322",
  x: 62.5376,
  y: 72.02,
  width: 203.98,
  height: 126.504,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_854_25322"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_d_854_25322",
  x: 178.462,
  y: 60.4756,
  width: 68.3179,
  height: 56.7339,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.411765 0 0 0 0 0.258824 0 0 0 0 0.972549 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_854_25322"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_854_25322",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_d_854_25322",
  x: 40.2363,
  y: 102.473,
  width: 135.873,
  height: 92.6206,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 16
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.836111 0 0 0 0 0.836111 0 0 0 0 0.895833 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_854_25322"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_854_25322",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_854_25322",
  x1: 269.849,
  y1: 95.9058,
  x2: 54.2161,
  y2: 41.9751,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8B98DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.200284,
  stopColor: "#C1CBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303741,
  stopColor: "#E9ECFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.310958,
  stopColor: "#DDE2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.333069,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.491969,
  stopColor: "#CED6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.857402,
  stopColor: "#94A0E3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DAE0FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_854_25322",
  x1: 268.792,
  y1: 90.5978,
  x2: -129.631,
  y2: 619.485,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_854_25322",
  x1: 268.068,
  y1: 89.8917,
  x2: -130.355,
  y2: 618.779,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_854_25322",
  x1: 233.094,
  y1: 78.8929,
  x2: 221.222,
  y2: 63.8887,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.325361,
  stopColor: "#FCFCFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E7EAF8"
})))));
export default SvgRejected;